import React, { useState, useContext } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { FilterBar } from "../../components/FilterBar";
import helpers from "../../utils/helpers";
import AuthContext from "../../context/AuthContext";
import ReactPaginate from "react-paginate";
import { Link, useLocation } from "react-router-dom";
import { capitalize, isEmpty, startCase } from "lodash";
import Pagination from "../../components/Pagination";
import { BiSolidRightArrow } from "react-icons/bi";
import obj, { formatNumber } from "../../utils/constants";
import moment from "moment";
import DatePicker from "react-datepicker";

export const BettingProfitLossTab = ({
  filter,
  setFilter,
  data,
  title,
  getData,
  betType,
  url,
  viewpage,
  handlePageClick,
  pageCount,
  redirectCasino,
  comission,
  summaryData,
  getFancy,
  setInnertab,
  total,
  total2,
  innertab,
  dataOld,
}) => {
  let { user } = useContext(AuthContext);
  const location = useLocation();
  const showDetail = (event, id) => {
    const detailDiv = document.getElementById(id);
    if (detailDiv) {
      if (detailDiv?.style?.display === "none") {
        detailDiv.style.setProperty("display", "contents");
        event.target.className = "fa-regular fa-square-minus pe-2 m-0";
      } else {
        detailDiv.style.setProperty("display", "none");
        event.target.className = "fa-regular fa-square-plus pe-2 m-0";
      }
    }
  };
  let { profileData } = useContext(AuthContext);
  const [showFancy, setShowFancy] = useState([]);

  const handelChange = (e) => {
    if (showFancy?.includes(e)) {
      setShowFancy((prev) => {
        return prev?.filter((res) => {
          return res !== e?._id;
        });
      });
    } else {
      if (betType == "fancy") {
        getFancy({
          ...e,
          userType: summaryData?.userType,
          userId: summaryData?._id,
        });
      }
      setShowFancy((prev) => {
        return [...prev, e?._id];
      });
    }
  };
  const [active, setActive] = useState([]);
  return (
    <div className="common-container">
      {/* <FilterBar filter={filter} setFilter={setFilter} getData={getData} /> */}

      <div className="inner-wrapper">
        <Form className="bet_status bettinghistory">
          <div className="d-flex align-items-center">
            <div
              className="bet-sec bet-period bettinghistory-tab"
              style={{ marginRight: "6px" }}
            >
              <Form.Label className="mb-0" style={{ marginBottom: "7px" }}>
                Period
              </Form.Label>
              <Form.Group className="form-group">
                <DatePicker
                  className="small_form_control"
                  selected={
                    filter.fromPeriod ? new Date(filter.fromPeriod) : null
                  }
                  onChange={(date) =>
                    setFilter({
                      ...filter,
                      fromPeriod: date.toISOString().split("T")[0],
                      filterByDay: "",
                    })
                  }
                  dateFormat="yyyy-MM-dd"
                  maxDate={new Date()}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                  placeholderText="Select a date"
                  onFocus={(e) => e.target.blur()}
                />
                <Form.Control
                  style={{ marginLeft: "4px" }}
                  className="small_form_control"
                  type="text"
                  placeholder="09:00"
                  disabled
                />
              </Form.Group>
            </div>

            <div className="bet-sec bet-period">
              <Form.Label
                style={{ marginRight: "2px", marginBottom: `0px` }}
                className="mb-0"
              >
                to
              </Form.Label>
              <Form.Group className="form-group">
                <DatePicker
                  className="small_form_control"
                  selected={filter.toPeriod ? new Date(filter.toPeriod) : null}
                  onChange={(date) =>
                    setFilter({
                      ...filter,
                      toPeriod: date.toISOString().split("T")[0],
                      filterByDay: "",
                    })
                  }
                  dateFormat="yyyy-MM-dd"
                  minDate={
                    filter?.fromPeriod
                      ? new Date(filter?.fromPeriod).toISOString().split("T")[0]
                      : new Date()
                  }
                  maxDate={new Date().toISOString().split("T")[0]}
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select" // or "scroll" if you prefer scroll-style dropdowns
                  placeholderText="Select a date"
                  onFocus={(e) => e.target.blur()}
                />
                <Form.Control
                  style={{ marginLeft: "4px", width: "47px" }}
                  className="small_form_control"
                  type="text"
                  placeholder="08:59"
                  disabled
                />
              </Form.Group>
            </div>
          </div>
          <div className="history-btn mt-2">
            <ul className="list-unstyled mb-0">
              <li>
                <Button
                  className={"me-0 theme_light_btn"}
                  onClick={(e) =>
                    setFilter({
                      ...filter,
                      filterByDay: "today",
                    })
                  }
                  style={{ padding: `0 10px`, lineHeight: `25px` }}
                >
                  Just For Today
                </Button>
              </li>
              <li>
                <Button
                  className={"me-0 theme_light_btn"}
                  onClick={(e) =>
                    setFilter({
                      ...filter,
                      filterByDay: "yesterday",
                    })
                  }
                  style={{ padding: `0 10px`, lineHeight: `25px` }}
                >
                  From Yesterday
                </Button>
              </li>
              <li>
                <Button className="theme_dark_btn" onClick={() => getData()}>
                  Get History
                </Button>
              </li>
            </ul>
          </div>
        </Form>
      </div>
      {dataOld?.data?.length == 0 || isEmpty(dataOld) ? (
        <div id="noReportMessage">
          <p className="p-0" style={{ marginBottom: "7px" }}>
            Betting History enables you to review the bets you have placed.{" "}
            <br />
            Specify the time period during which your bets were placed, the type
            of markets on which the bets were placed, and the sport.
          </p>
          <p className="p-0" style={{ marginBottom: "7px" }}>
            Betting History is available online for the past 62 days.
          </p>
          <p className="p-0" style={{ marginBottom: "7px" }}>
            User can search up to 14 days records per query only .
          </p>
        </div>
      ) : (
        <section className="account-table my-bet-sec">
          <div className="profile-tab">
            <div className="my_account_table_wrap">
              <div className="table-main-wrapper">
                <div id="report" data-report="profitAndLossReport">
                  <ul
                    style={{ paddingLeft: "0" }}
                    id="spotsUl"
                    className="total-show mt-2"
                  >
                    <li id="totalPL">
                      Total P/L: PBU
                      <span
                        style={{ marginLeft: "3px" }}
                        className={total > 0 ? "" : "red"}
                      >
                        {console.log("total", total)}
                        {total > 0
                          ? helpers?.currencyFormat(
                              helpers?.truncateDecimals(total, 2)
                            )
                          : `(${helpers?.currencyFormat(
                              helpers?.truncateDecimals(Math.abs(total), 2)
                            )})`}
                      </span>
                    </li>

                    {title !== "casino" && (
                      <>
                        <li id="sumOfQuery" className="sports-switch">
                          PBU{" "}
                          <span
                            style={{ marginLeft: "3px" }}
                            className={total2 > 0 ? "" : "red"}
                          >
                            {total2 > 0
                              ? helpers?.currencyFormat(
                                  helpers?.truncateDecimals(total2, 2)
                                )
                              : `(${helpers?.currencyFormat(
                                  helpers?.truncateDecimals(Math.abs(total2), 2)
                                )})`}
                          </span>
                        </li>
                        <li className="sports-switch">
                          <select
                            onChange={(e) => {
                              setInnertab(e.target.value);
                            }}
                            value={innertab}
                          >
                            <option value="all">ALL</option>
                            <option value="4">CRICKET</option>{" "}
                            <option value="2">TENNIS</option>{" "}
                            <option value="1">SOCCER</option>
                          </select>
                        </li>{" "}
                      </>
                    )}
                  </ul>

                  <div className="profit_loss_table">
                    {title === "casino" ? (
                      <table
                        id="reportTable"
                        className="table01 table-pnl"
                        style={{ display: `table` }}
                      >
                        <tbody>
                          <tr>
                            <th scope="col" style={{ textAlign: "left" }}>
                              Market
                            </th>
                            <th scope="col" style={{ textAlign: "right" }}>
                              Profit / Loss
                            </th>
                          </tr>

                          {data?.data && data?.data?.length > 0 ? (
                            data?.data?.map((item, index) => {
                              return (
                                <>
                                  <tr
                                    id="summary0"
                                    style={{ display: "table-row" }}
                                    key={index + 1}
                                  >
                                    <td id="title" className="">
                                      Casino
                                      {/* <span className="angle_unicode">▸</span> */}
                                      <img
                                        class="fromto"
                                        src={require("../../assets/images/transparent.gif")}
                                      />
                                      <strong> {item?.casinoName}</strong>
                                      {/* <span className="angle_unicode">▸</span> */}
                                      <img
                                        class="fromto"
                                        src={require("../../assets/images/transparent.gif")}
                                      />
                                      {moment(item?.timeInserted).format(
                                        "YYYY-MM-DD hh:mm:ss"
                                      )}
                                    </td>
                                    <td className="text-right">
                                      {Math.sign(item?.playerPL) === -1 ? (
                                        <span className="text-danger">
                                          (
                                          {helpers.currencyFormat(
                                            Math.abs(item?.playerPL.toFixed(2))
                                          )}
                                          )
                                        </span>
                                      ) : (
                                        <span className="">
                                          {helpers.currencyFormat(
                                            Math.abs(item?.playerPL.toFixed(2))
                                          )}
                                        </span>
                                      )}

                                      <span
                                        style={{
                                          color: "#2789ce",
                                          // marginLeft: "4px",
                                        }}
                                      >
                                        {active.includes(item?._id) ? (
                                          <img
                                            style={{
                                              height: "15px",
                                              marginRight: "5px",
                                              paddingLeft: `7px`,
                                            }}
                                            onClick={() =>
                                              setActive((prev) => {
                                                return prev?.filter((res) => {
                                                  return res !== item?._id;
                                                });
                                              })
                                            }
                                            src={require("../../assets/images/expand-open.png")}
                                          />
                                        ) : (
                                          <img
                                            style={{
                                              height: "15px",
                                              marginRight: "5px",
                                              paddingLeft: `7px`,
                                            }}
                                            onClick={() =>
                                              setActive((prev) => {
                                                return [...prev, item?._id];
                                              })
                                            }
                                            src={require("../../assets/images/expand-close.png")}
                                          />
                                        )}{" "}
                                      </span>
                                      {/* <i
                                         id={"icon_" + item?.platformTxId}
                                         class="fas fa-plus-square"
                                         onClick={(e) =>
                                           showDetail1(e, item?.platformTxId)
                                         }
                                       ></i> */}
                                    </td>
                                  </tr>

                                  {active?.includes(item?._id) && (
                                    <tr
                                      className="expand"
                                      id={item?._id}
                                      // style={{ display: getProperty }}
                                      key={item?._id}
                                    >
                                      <td
                                        colSpan="4"
                                        style={{ position: "relative" }}
                                        className="expand_wrap"
                                      >
                                        <table className="table-commission">
                                          <tbody>
                                            <tr>
                                              <th style={{ textAlign: "left" }}>
                                                Platform
                                              </th>
                                              <th>Valid Turnover</th>
                                              <th>Win/Loss</th>
                                              <th>PT/Comm.</th>
                                              <th>Profit / Loss</th>
                                              <th>Action</th>
                                            </tr>
                                            <tr
                                              id="txRow0"
                                              style={{
                                                display: "table-row",
                                              }}
                                              className="even"
                                              // key={i + 1}
                                            >
                                              <td
                                                id="betID"
                                                className="casinobtnleft"
                                              >
                                                <Button
                                                  style={{
                                                    fontSize: "10px",
                                                    padding: "4px",
                                                  }}
                                                  className="theme_dark_btn casinobtn "
                                                  onClick={() =>
                                                    redirectCasino(
                                                      item?.clientName,
                                                      item?.platform,
                                                      item?.platformTxId,
                                                      1
                                                    )
                                                  }
                                                >
                                                  {item.platform}
                                                </Button>
                                              </td>
                                              <td>0.00</td>
                                              <td>
                                                {" "}
                                                {Math.sign(item?.playerPL) ===
                                                -1 ? (
                                                  <span className="text-danger">
                                                    (
                                                    {helpers.currencyFormat(
                                                      Math.abs(
                                                        item?.playerPL.toFixed(
                                                          2
                                                        )
                                                      )
                                                    )}
                                                    )
                                                  </span>
                                                ) : (
                                                  <span className="">
                                                    {helpers.currencyFormat(
                                                      Math.abs(
                                                        item?.playerPL.toFixed(
                                                          2
                                                        )
                                                      )
                                                    )}
                                                  </span>
                                                )}
                                              </td>
                                              <td>0.00</td>
                                              <td>
                                                {" "}
                                                {Math.sign(item?.playerPL) ===
                                                -1 ? (
                                                  <span className="text-danger">
                                                    (
                                                    {helpers.currencyFormat(
                                                      Math.abs(
                                                        item?.playerPL.toFixed(
                                                          2
                                                        )
                                                      )
                                                    )}
                                                    )
                                                  </span>
                                                ) : (
                                                  <span className="">
                                                    {helpers.currencyFormat(
                                                      Math.abs(
                                                        item?.playerPL.toFixed(
                                                          2
                                                        )
                                                      )
                                                    )}
                                                  </span>
                                                )}
                                              </td>
                                              <td>
                                                <Button
                                                  style={{
                                                    fontSize: "10px",
                                                    padding: "4px",
                                                  }}
                                                  className="theme_dark_btn casinobtn"
                                                  onClick={() =>
                                                    redirectCasino(
                                                      item?.clientName,
                                                      item?.platform,
                                                      item?.platformTxId,
                                                      2
                                                    )
                                                  }
                                                >
                                                  Result
                                                </Button>
                                              </td>
                                            </tr>
                                            <tr class="casino-grand-total">
                                              <td>Grand Total</td>
                                              <td id="totalTurnover">0.00</td>
                                              <td id="totalPayout">
                                                {Math.sign(item?.playerPL) ===
                                                -1 ? (
                                                  <span className="text-danger">
                                                    (
                                                    {helpers.currencyFormat(
                                                      Math.abs(
                                                        item?.playerPL.toFixed(
                                                          2
                                                        )
                                                      )
                                                    )}
                                                    )
                                                  </span>
                                                ) : (
                                                  <span className="">
                                                    {helpers.currencyFormat(
                                                      Math.abs(
                                                        item?.playerPL.toFixed(
                                                          2
                                                        )
                                                      )
                                                    )}
                                                  </span>
                                                )}
                                              </td>
                                              <td id="totalTaxRebate">0.00</td>
                                              <td id="totalBalance">
                                                {Math.sign(item?.playerPL) ===
                                                -1 ? (
                                                  <span className="text-danger">
                                                    (
                                                    {helpers.currencyFormat(
                                                      Math.abs(
                                                        item?.playerPL.toFixed(
                                                          2
                                                        )
                                                      )
                                                    )}
                                                    )
                                                  </span>
                                                ) : (
                                                  <span className="">
                                                    {helpers.currencyFormat(
                                                      Math.abs(
                                                        item?.playerPL.toFixed(
                                                          2
                                                        )
                                                      )
                                                    )}
                                                  </span>
                                                )}
                                              </td>
                                              <td></td>
                                            </tr>
                                          </tbody>
                                        </table>{" "}
                                        <img
                                          class="expand-arrow-R"
                                          style={{ top: "0" }}
                                          src={require("../../assets/images/transparent.gif")}
                                        ></img>
                                      </td>
                                    </tr>
                                  )}
                                </>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan={10}>
                                <span>
                                  You have no bets in this time period.
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    ) : (
                      <table
                        id="reportTable"
                        className="table01 table-pnl"
                        style={{ display: `table` }}
                      >
                        <tbody>
                          <tr>
                            <th width="" className="align-L">
                              Market
                            </th>
                            <th width="15%">Start Time</th>
                            <th width="15%">Settled date</th>
                            <th width="18%">Profit/Loss</th>
                          </tr>
                          {data?.data && data?.data?.length > 0 ? (
                            data?.data?.map((item, index) => {
                              // console.log("--------->",item,item?.updatedAt)
                              const resultTotalStake = item?.bets_list?.reduce(
                                (a, v) => {
                                  a = parseFloat(a) + parseFloat(v.amount);
                                  return a;
                                },
                                0
                              );
                              const backTotalProfitAmount =
                                item?.bets_list?.reduce((a, v) => {
                                  if (
                                    v?.betType === "back" &&
                                    v?.teamSelectionWin === v?.selectionId
                                  ) {
                                    a =
                                      parseFloat(a) +
                                      parseFloat(v.profitAmount);
                                  }

                                  return a;
                                }, 0);

                              const backTotalLoseAmount =
                                item?.bets_list?.reduce((a, v) => {
                                  if (
                                    v?.betType === "back" &&
                                    v?.teamSelectionWin !== v?.selectionId
                                  ) {
                                    a =
                                      parseFloat(a) + parseFloat(v.loseAmount);
                                  }
                                  return a;
                                }, 0);

                              let backSubTotalresult =
                                backTotalProfitAmount > backTotalLoseAmount
                                  ? backTotalProfitAmount - backTotalLoseAmount
                                  : -(
                                      backTotalLoseAmount -
                                      backTotalProfitAmount
                                    );

                              const layTotalProfitAmount =
                                item?.bets_list?.reduce((a, v) => {
                                  if (
                                    v?.betType === "lay" &&
                                    v?.teamSelectionWin !== v?.selectionId
                                  ) {
                                    a =
                                      parseFloat(a) +
                                      parseFloat(v.profitAmount);
                                  }
                                  return a;
                                }, 0);

                              const layTotalLoseAmount =
                                item?.bets_list?.reduce((a, v) => {
                                  if (
                                    v?.betType === "lay" &&
                                    v?.teamSelectionWin === v?.selectionId
                                  ) {
                                    a =
                                      parseFloat(a) + parseFloat(v.loseAmount);
                                  }
                                  return a;
                                }, 0);

                              let laySubTotalresult =
                                layTotalProfitAmount > layTotalLoseAmount
                                  ? layTotalProfitAmount - layTotalLoseAmount
                                  : -(
                                      layTotalLoseAmount - layTotalProfitAmount
                                    );
                              // console.log("backSubTotalresult",backSubTotalresult);
                              //console.log("laySubTotalresult",laySubTotalresult);
                              let marketSubTotal =
                                backSubTotalresult + laySubTotalresult;
                              const yesTotalProfitAmount =
                                item?.bets_list?.reduce((a, v) => {
                                  if (
                                    v?.type == "Yes" &&
                                    v?.decisionRun >= v?.betRun
                                  ) {
                                    a =
                                      parseFloat(a) +
                                      parseFloat(v.profitAmount);
                                  }
                                  return a;
                                }, 0);

                              const yesTotalLoseAmount =
                                item?.bets_list?.reduce((a, v) => {
                                  if (
                                    v?.type == "Yes" &&
                                    v?.decisionRun < v?.betRun
                                  ) {
                                    a =
                                      parseFloat(a) + parseFloat(v.loseAmount);
                                  }
                                  return a;
                                }, 0);

                              let yesSubTotalresult =
                                yesTotalProfitAmount > yesTotalLoseAmount
                                  ? yesTotalProfitAmount - yesTotalLoseAmount
                                  : -(
                                      yesTotalLoseAmount - yesTotalProfitAmount
                                    );

                              const noTotalProfitAmount =
                                item?.bets_list?.reduce((a, v) => {
                                  if (
                                    v?.type == "No" &&
                                    v?.decisionRun < v?.betRun
                                  ) {
                                    a =
                                      parseFloat(a) +
                                      parseFloat(v.profitAmount);
                                  }
                                  return a;
                                }, 0);
                              const noTotalLoseAmount = item?.bets_list?.reduce(
                                (a, v) => {
                                  if (
                                    v?.type == "No" &&
                                    v?.decisionRun >= v?.betRun
                                  ) {
                                    a =
                                      parseFloat(a) + parseFloat(v.loseAmount);
                                  }
                                  return a;
                                },
                                0
                              );
                              let noSubTotalresult =
                                noTotalProfitAmount > noTotalLoseAmount
                                  ? noTotalProfitAmount - noTotalLoseAmount
                                  : -(noTotalLoseAmount - noTotalProfitAmount);

                              // const resultCommission = item?.bets_list?.reduce(
                              //   (a, v) => {
                              //     a =
                              //       parseFloat(a) +
                              //       parseFloat(v.commission ? v.commission : 0);
                              //     return a;
                              //   },
                              //   0
                              // );

                              let fancyMarketSubTotal =
                                yesSubTotalresult + noSubTotalresult;

                              // let fancyNetAmount =
                              //   fancyMarketSubTotal -
                              //   (fancyMarketSubTotal *
                              //     profileData?.commission) /
                              //   100;
                              let fancyNetAmount = fancyMarketSubTotal;

                              let v =
                                marketSubTotal > 0 ? marketSubTotal / 100 : "";
                              // console.log("marketSubTotal",marketSubTotal);
                              let netAmount = 0;
                              if (betType == "toss" || betType == "tie") {
                                netAmount = marketSubTotal;
                              } else {
                                netAmount = netAmount = marketSubTotal - v;
                              }

                              return (
                                <>
                                  <tr
                                    id="summary0"
                                    style={{ display: "table-row" }}
                                    key={index + 1}
                                  >
                                    <td className="text-start">
                                      <span
                                        style={{ textTransform: "uppercase" }}
                                      >
                                        {obj.betCheckObj[item?.eventType]}
                                      </span>
                                      <img
                                        class="fromto"
                                        src={require("../../assets/images/transparent.gif")}
                                      />
                                      <strong>
                                        {betType === "casino"
                                          ? item?.casinoName
                                          : item?.matchName
                                          ? item?.matchName
                                          : item?.eventName}
                                      </strong>
                                      <img
                                        class="fromto"
                                        src={require("../../assets/images/transparent.gif")}
                                      />
                                      {(betType == "betfair" && item?.market) ||
                                        "Match Odds"}
                                      {betType === "sportBook" && "SportBook"}
                                      {betType === "fancy" && "Fancy"}{" "}
                                      {betType === "casino" && item?.casinoType}{" "}
                                      {betType === "toss" && "Toss"}{" "}
                                      {betType === "bookmaker" && "Bookmaker"}{" "}
                                    </td>
                                    <td
                                      style={{ textAlign: "right" }}
                                      id="startTime"
                                    >
                                      {" "}
                                      {moment(item?.eventDateTime).format(
                                        "YYYY-MM-DD hh:mm:ss"
                                      )}
                                    </td>
                                    <td
                                      style={{ textAlign: "right" }}
                                      id="settledDate"
                                    >
                                      {" "}
                                      {moment(item?.updatedAt).format(
                                        "YYYY-MM-DD hh:mm:ss"
                                      )}
                                    </td>
                                    <td className="text-end">
                                      <a
                                        id="pl0"
                                        className="expand-open"
                                        href="javascript:void(0)"
                                        style={{
                                          textDecoration: "none",
                                          paddingRight: "0",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {betType == "fancy" ? (
                                          fancyNetAmount > 0 ? (
                                            helpers?.currencyFormat(
                                              Math.abs(
                                                fancyNetAmount.toFixed(2)
                                              )
                                            )
                                          ) : (
                                            <span
                                              style={{
                                                paddingRight: "0",
                                                marginRight: `0`,
                                                fontSize: "12px",
                                              }}
                                              className="red"
                                            >
                                              (
                                              {helpers?.currencyFormat(
                                                Math.abs(
                                                  fancyNetAmount.toFixed(2)
                                                )
                                              )}
                                              )
                                            </span>
                                          )
                                        ) : netAmount > 0 ? (
                                          helpers?.currencyFormat(
                                            netAmount.toFixed(2)
                                          )
                                        ) : (
                                          <span
                                            style={{
                                              paddingRight: "0",
                                              marginRight: `0`,
                                              fontSize: "12px",
                                            }}
                                            className="red"
                                          >
                                            {/* {console.log("netAmount",helpers?.currencyFormat(netAmount))} */}
                                            (
                                            {helpers?.currencyFormat(
                                              Math.abs(netAmount.toFixed(2))
                                            )}
                                            )
                                          </span>
                                        )}{" "}
                                        <span
                                          style={{
                                            color: "#2789ce",
                                            paddingLeft: "2px",
                                            marginRight: `0px`,
                                            paddingRight: `0px`,
                                          }}
                                        >
                                          {active.includes(item?._id) ? (
                                            <img
                                              style={{
                                                height: "15px",
                                                marginRight: "5px",
                                                marginTop: `-4px`,
                                              }}
                                              onClick={() =>
                                                setActive((prev) => {
                                                  return prev?.filter((res) => {
                                                    return res !== item?._id;
                                                  });
                                                })
                                              }
                                              src={require("../../assets/images/expand-open.png")}
                                            />
                                          ) : (
                                            <img
                                              style={{
                                                height: "15px",
                                                marginRight: "5px",
                                                marginTop: `-4px`,
                                              }}
                                              onClick={() =>
                                                setActive((prev) => {
                                                  return [...prev, item?._id];
                                                })
                                              }
                                              src={require("../../assets/images/expand-close.png")}
                                            />
                                          )}{" "}
                                          {item?.matchBetId ||
                                            item?.sessionBetId}
                                        </span>
                                      </a>
                                      {/* <i
                                           id={"icon_" + item?._id}
                                           className="fas fa-plus-square"
                                           onClick={(e) =>
                                             showDetail(e, item?._id)
                                           }
                                         ></i> */}
                                    </td>
                                  </tr>
                                  {item?.bets_list?.length > 0 &&
                                    active?.includes(item?._id) && (
                                      <tr
                                        className="expand"
                                        id={item?._id}
                                        // style={{ display: getProperty }}
                                        key={item?._id}
                                      >
                                        <td
                                          colSpan="4"
                                          style={{ position: "relative" }}
                                          className="expand_wrap"
                                        >
                                          <table className="table-commission table-commission1">
                                            <tbody>
                                              <tr>
                                                <th width="9%">Bet ID</th>
                                                <th
                                                  width=""
                                                  style={{ textAlign: "right" }}
                                                >
                                                  Selection
                                                </th>
                                                <th
                                                  width="9%"
                                                  style={{ textAlign: "right" }}
                                                >
                                                  Odds
                                                </th>
                                                <th
                                                  width="13%"
                                                  style={{ textAlign: "right" }}
                                                >
                                                  Stake
                                                </th>
                                                <th
                                                  width="8%"
                                                  style={{ textAlign: "right" }}
                                                >
                                                  Type
                                                </th>
                                                <th
                                                  width="16%"
                                                  style={{ textAlign: "right" }}
                                                >
                                                  Placed
                                                </th>
                                                <th
                                                  width="23%"
                                                  style={{ textAlign: "right" }}
                                                >
                                                  Profit/Loss
                                                </th>
                                              </tr>
                                              {item?.bets_list?.map(
                                                (betData, i) => {
                                                  return (
                                                    <tr
                                                      id="txRow0"
                                                      style={{
                                                        display: "table-row",
                                                      }}
                                                      className="even"
                                                      key={i + 1}
                                                    >
                                                      <td id="betID">
                                                        {betType == "fancy"
                                                          ? betData?.sessionBetId
                                                          : betData?.matchBetId}
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "right",
                                                        }}
                                                        id="matchSelection"
                                                      >
                                                        {betType == "fancy" ||
                                                        betType ==
                                                          "sportBook" ? (
                                                          betType ==
                                                          "sportBook" ? (
                                                            <>
                                                              {
                                                                betData?.fancyName
                                                              }{" "}
                                                              <img
                                                                class="fromto"
                                                                src={require("../../assets/images/transparent.gif")}
                                                              />
                                                              {
                                                                betData?.runnerName
                                                              }{" "}
                                                            </>
                                                          ) : (
                                                            betData?.fancyName
                                                          )
                                                        ) : (
                                                          betData?.teamName
                                                        )}
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "right",
                                                        }}
                                                        id="txOddsMatched"
                                                      >
                                                        {betType == "fancy"
                                                          ? betData?.betRun +
                                                            "/" +
                                                            betData?.bhav
                                                          : betData?.bhav}
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "right",
                                                        }}
                                                        id="txStake"
                                                      >
                                                        {" "}
                                                        {betData?.amount}
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "right",
                                                        }}
                                                      >
                                                        {betType == "fancy" ? (
                                                          <span
                                                            style={{
                                                              color:
                                                                betData?.type ==
                                                                "No"
                                                                  ? "red"
                                                                  : "rgb(39, 137, 206)",
                                                            }}
                                                            id="matchType"
                                                            className={
                                                              betData?.type ===
                                                              "No"
                                                                ? "lay"
                                                                : "back"
                                                            }
                                                          >
                                                            {capitalize(
                                                              betData?.type
                                                            )}
                                                          </span>
                                                        ) : (
                                                          <span
                                                            style={{
                                                              color:
                                                                betData?.betType ==
                                                                "lay"
                                                                  ? "red"
                                                                  : "rgb(39, 137, 206)",
                                                            }}
                                                            id="matchType"
                                                            className={
                                                              betData?.betType ===
                                                              "lay"
                                                                ? "lay"
                                                                : "back"
                                                            }
                                                          >
                                                            {capitalize(
                                                              betData?.betType
                                                            )}
                                                          </span>
                                                        )}
                                                      </td>
                                                      <td
                                                        style={{
                                                          textAlign: "right",
                                                        }}
                                                        id="placed"
                                                      >
                                                        {moment(
                                                          betData?.createdAt
                                                        ).format(
                                                          "YYYY-MM-DD hh:mm:ss"
                                                        )}
                                                      </td>
                                                      {betType == "fancy" ? (
                                                        <td
                                                          style={{
                                                            textAlign: "right",
                                                          }}
                                                          id="txLiability"
                                                        >
                                                          {betData?.type ==
                                                          "No" ? (
                                                            betData?.decisionRun <
                                                            betData?.betRun ? (
                                                              <span>
                                                                {helpers?.currencyFormat(
                                                                  betData?.profitAmount,
                                                                  2
                                                                )}
                                                              </span>
                                                            ) : (
                                                              <span className="red">
                                                                (
                                                                {helpers?.currencyFormat(
                                                                  betData?.loseAmount,
                                                                  2
                                                                )}
                                                                )
                                                              </span>
                                                            )
                                                          ) : betData?.decisionRun >=
                                                            betData?.betRun ? (
                                                            <span>
                                                              {helpers?.currencyFormat(
                                                                betData?.profitAmount,
                                                                2
                                                              )}
                                                            </span>
                                                          ) : (
                                                            <span className="red">
                                                              (
                                                              {helpers?.currencyFormat(
                                                                betData?.loseAmount,
                                                                2
                                                              )}
                                                              )
                                                            </span>
                                                          )}
                                                        </td>
                                                      ) : (betData?.teamSelectionWin ==
                                                          betData?.selectionId &&
                                                          betData?.betType ==
                                                            "back") ||
                                                        (betData?.teamSelectionWin !=
                                                          betData?.selectionId &&
                                                          betData?.betType ==
                                                            "lay") ? (
                                                        <td
                                                          style={{
                                                            textAlign: "right",
                                                          }}
                                                          id="txLiability"
                                                        >
                                                          {helpers?.currencyFormat(
                                                            betData?.profitAmount,
                                                            2
                                                          )}
                                                        </td>
                                                      ) : (
                                                        <td
                                                          style={{
                                                            textAlign: "right",
                                                          }}
                                                          id="txLiability"
                                                        >
                                                          <span className="red">
                                                            (
                                                            {helpers?.currencyFormat(
                                                              betData?.loseAmount,
                                                              2
                                                            )}
                                                            )
                                                          </span>
                                                        </td>
                                                      )}
                                                    </tr>
                                                  );
                                                }
                                              )}

                                              <tr className="sum-pl">
                                                <td colSpan="7">
                                                  <dl
                                                    style={{
                                                      marginBottom: "0",
                                                    }}
                                                  >
                                                    <dt>Total Stakes</dt>
                                                    <dd id="totalStakes">
                                                      {helpers?.currencyFormat(
                                                        resultTotalStake,
                                                        2
                                                      )}
                                                    </dd>
                                                    {betType == "fancy" ? (
                                                      <>
                                                        <dt id="backSubTotalTitle">
                                                          Yes subtotal
                                                        </dt>
                                                        <dd id="backSubTotal">
                                                          {" "}
                                                          {yesSubTotalresult ? (
                                                            yesTotalProfitAmount >
                                                            yesTotalLoseAmount ? (
                                                              helpers?.currencyFormat(
                                                                Math.abs(
                                                                  yesSubTotalresult,
                                                                  2
                                                                )
                                                              )
                                                            ) : (
                                                              <span className="red">
                                                                (
                                                                {helpers?.currencyFormat(
                                                                  Math.abs(
                                                                    yesSubTotalresult,
                                                                    2
                                                                  )
                                                                )}
                                                                )
                                                              </span>
                                                            )
                                                          ) : (
                                                            helpers?.currencyFormat(
                                                              Math.abs(
                                                                yesSubTotalresult,
                                                                2
                                                              )
                                                            )
                                                          )}
                                                        </dd>

                                                        <dt id="laySubTotalTitle">
                                                          No subtotal
                                                        </dt>
                                                        <dd id="laySubTotal">
                                                          {noSubTotalresult ? (
                                                            noTotalProfitAmount >
                                                            noTotalLoseAmount ? (
                                                              helpers?.currencyFormat(
                                                                Math.abs(
                                                                  noSubTotalresult,
                                                                  2
                                                                )
                                                              )
                                                            ) : (
                                                              <span className="red">
                                                                (
                                                                {helpers?.currencyFormat(
                                                                  Math.abs(
                                                                    noSubTotalresult,
                                                                    2
                                                                  )
                                                                )}
                                                                )
                                                              </span>
                                                            )
                                                          ) : (
                                                            helpers?.currencyFormat(
                                                              Math.abs(
                                                                noSubTotalresult,
                                                                2
                                                              )
                                                            )
                                                          )}
                                                        </dd>
                                                      </>
                                                    ) : (
                                                      <>
                                                        <dt id="backSubTotalTitle">
                                                          Back subtotal
                                                        </dt>
                                                        <dd id="backSubTotal">
                                                          {" "}
                                                          {backSubTotalresult ? (
                                                            backTotalProfitAmount >
                                                            backTotalLoseAmount ? (
                                                              helpers?.currencyFormat(
                                                                Math.abs(
                                                                  backSubTotalresult
                                                                )
                                                              )
                                                            ) : (
                                                              <span className="red">
                                                                (
                                                                {helpers?.currencyFormat(
                                                                  Math.abs(
                                                                    backSubTotalresult
                                                                  )
                                                                )}
                                                                )
                                                              </span>
                                                            )
                                                          ) : (
                                                            helpers?.currencyFormat(
                                                              Math.abs(
                                                                backSubTotalresult
                                                              )
                                                            )
                                                          )}
                                                        </dd>

                                                        <dt id="laySubTotalTitle">
                                                          Lay subtotal
                                                        </dt>
                                                        <dd id="laySubTotal">
                                                          {" "}
                                                          {layTotalProfitAmount >
                                                          layTotalLoseAmount ? (
                                                            helpers?.currencyFormat(
                                                              Math.abs(
                                                                laySubTotalresult,
                                                                2
                                                              )
                                                            )
                                                          ) : (
                                                            <span className="red">
                                                              (
                                                              {helpers?.currencyFormat(
                                                                Math.abs(
                                                                  laySubTotalresult,
                                                                  2
                                                                )
                                                              )}
                                                              )
                                                            </span>
                                                          )}
                                                        </dd>
                                                      </>
                                                    )}

                                                    <dt>Market subtotal</dt>

                                                    {betType == "fancy" ? (
                                                      <dd id="marketTotal">
                                                        {yesTotalProfitAmount >
                                                          yesTotalLoseAmount ||
                                                        noTotalProfitAmount >
                                                          noTotalLoseAmount ? (
                                                          helpers?.currencyFormat(
                                                            Math.abs(
                                                              fancyMarketSubTotal,
                                                              2
                                                            )
                                                          )
                                                        ) : (
                                                          <span className="red">
                                                            (
                                                            {helpers?.currencyFormat(
                                                              Math.abs(
                                                                fancyMarketSubTotal,
                                                                2
                                                              )
                                                            )}
                                                            )
                                                          </span>
                                                        )}
                                                      </dd>
                                                    ) : (
                                                      <>
                                                        <dd id="marketTotal">
                                                          {backTotalProfitAmount >
                                                            backTotalLoseAmount ||
                                                          layTotalProfitAmount >
                                                            layTotalLoseAmount ? (
                                                            helpers?.currencyFormat(
                                                              Math.abs(
                                                                marketSubTotal,
                                                                2
                                                              )
                                                            )
                                                          ) : (
                                                            <span className="red">
                                                              (
                                                              {helpers?.currencyFormat(
                                                                Math.abs(
                                                                  marketSubTotal,
                                                                  2
                                                                )
                                                              )}
                                                              )
                                                            </span>
                                                          )}
                                                        </dd>
                                                      </>
                                                    )}

                                                    <dt className="net_total">
                                                      Net Market Total
                                                    </dt>
                                                    {betType == "fancy" ? (
                                                      <dd
                                                        id="netTotal"
                                                        className="net_total"
                                                      >
                                                        {fancyNetAmount > 0 ? (
                                                          helpers?.currencyFormat(
                                                            fancyNetAmount,
                                                            2
                                                          )
                                                        ) : (
                                                          <span className="red">
                                                            (
                                                            {helpers?.currencyFormat(
                                                              Math.abs(
                                                                fancyNetAmount,
                                                                2
                                                              )
                                                            )}
                                                            )
                                                          </span>
                                                        )}
                                                      </dd>
                                                    ) : (
                                                      <>
                                                        <dd
                                                          id="netTotal"
                                                          className="net_total"
                                                        >
                                                          {netAmount > 0 ? (
                                                            helpers?.currencyFormat(
                                                              netAmount,
                                                              2
                                                            )
                                                          ) : (
                                                            <span className="red">
                                                              (
                                                              {helpers?.currencyFormat(
                                                                Math.abs(
                                                                  netAmount,
                                                                  2
                                                                )
                                                              )}
                                                              )
                                                            </span>
                                                          )}
                                                        </dd>
                                                      </>
                                                    )}
                                                  </dl>
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                          <img
                                            class="expand-arrow-R"
                                            style={{ top: "0" }}
                                            src={require("../../assets/images/transparent.gif")}
                                          ></img>
                                        </td>
                                      </tr>
                                    )}
                                </>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="9" className="text-start">
                                <span>
                                  You have no bets in this time period.
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}{" "}
                    <p className="table-other">
                      Profit and Loss is shown net of commission.
                    </p>
                  </div>
                  {/* {data?.data?.length > 0 && (
                       <PaginationComp
                         viewpage={viewpage}
                         handlePageClick={handlePageClick}
                         pageCount={pageCount}
                       />
                     )} */}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </div>
  );
};
